// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyState_wrapper__rUYsn","favoritesIcon":"EmptyState_favoritesIcon__3Jr3I","searchIcon":"EmptyState_searchIcon__QSaem","notFoundIcon":"EmptyState_notFoundIcon__ucnHd"};